import { render, staticRenderFns } from "./AskforDialog.vue?vue&type=template&id=4c1507a5&scoped=true&"
import script from "./AskforDialog.vue?vue&type=script&lang=js&"
export * from "./AskforDialog.vue?vue&type=script&lang=js&"
import style0 from "./AskforDialog.vue?vue&type=style&index=0&id=4c1507a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1507a5",
  null
  
)

export default component.exports